import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const ComparisonResultsTable = lazy(() =>
  import(/* webpackChunkName: "ComparisonResultsTable" */ '../../components/results/ComparisonResultsTable')
);

export default function AsyncComparisonResultsTable({__placeholder_html__, ...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <ComparisonResultsTable {...props} />
    </Suspense>
  );
}
